import React from 'react';
import { apiPost } from '../../../helpers/apiHelper';
import { standortUrlSelector, landingPageUrlSelector } from '../../../modules/selectors/url';
import Spinner from '../../components/Spinner/Spinner';
import { connect } from 'react-redux';
import loadable from '@loadable/component';
import { Helmet } from 'react-helmet';

const NotFound = loadable(() => import('../ErrorPages/NotFound/NotFound'));

class LandingPageContent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            foundContent: null,
        };
        this.getLandingPageContent = this.getLandingPageContent.bind(this);
    }

    getLandingPageContent() {
        apiPost(
            '/api/v1/serviceLocationLandingPage',
            {
                standortUrl: this.props.standortUrl,
                mainUrl: window.location.pathname.split('/')[1],
                url: window.location.pathname.split('/')[2]
            },

            (err, foundContent) => {
                if (err) console.error(err);
                else this.setState({ foundContent });
            }
        );
    }

    componentDidMount() {
        this.getLandingPageContent();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.landingPageUrl !== prevProps.landingPageUrl) this.getLandingPageContent();
    }

    render() {
        const { foundContent } = this.state;

        return foundContent ? (

            <div className='uk-container'>
                <Helmet
                    script={[{
                        type: 'application/ld+json',
                        innerHTML: `${foundContent.script_1}`
                    }]}
                />
                <Helmet
                    script={[{
                        type: 'application/ld+json',
                        innerHTML: `${foundContent.script_2}`
                    }]}
                />
                <div dangerouslySetInnerHTML={{ __html: foundContent.content }} />
            </div>
        ) : foundContent === null ? (
            <div>
                <Spinner />
            </div>
        ) : (
            <div>
                <NotFound />
            </div>
        );
    }
}

const mapStateToProps = state => ({
    standortUrl: standortUrlSelector(state),
    landingPageUrl: landingPageUrlSelector(state),
});

export default connect(mapStateToProps)(LandingPageContent);